import { render, staticRenderFns } from "./ListIndicacoes.vue?vue&type=template&id=0a3adda6&"
import script from "./ListIndicacoes.vue?vue&type=script&lang=js&"
export * from "./ListIndicacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports